export default __webpack_public_path__ + "static/media/investment.19d2194d.svg";